export const statusList = [
  { id: "active", name: "Active" },
  { id: "inactive", name: "Inactive" },
];

export const isNotHaveRoutesList = [
  { id: false, name: "Yes" },
  { id: true, name: "No" },
];

export const isMaxLevelList = [
  { id: true, name: "Yes" },
  { id: false, name: "No" },
];
